export default __webpack_public_path__ + "static/media/left-arrow.edf9078b.svg";